import request from "../../utils/request";
import { Result } from "../../models/general";

// HR-defined custom employee fields (text only). Consumed by the employee profile editor and
// surfaced to the Document Template Manager as {{custom_<key>}} placeholders.

export interface CustomFieldDefinitionView {
  id: number;
  key: string;          // placeholder is custom_<key>
  label: string;
  labelAr?: string;
  displayOrder: number;
}

export interface CustomFieldDefinitionInput {
  id?: number;
  label: string;
  labelAr?: string;
  displayOrder: number;
}

export interface UserCustomFieldValueView {
  definitionId: number;
  key: string;
  label: string;
  labelAr?: string;
  value?: string;
}

export interface UserCustomFieldValueInput {
  definitionId: number;
  value?: string;
}

// ── Definitions ──────────────────────────────────────────────────────────────

export async function getCustomFieldDefinitions(): Promise<Result<CustomFieldDefinitionView[]>> {
  const response = await request.get<Result<CustomFieldDefinitionView[]>>("CustomField/definitions");
  return response.data;
}

export async function createCustomFieldDefinition(
  input: CustomFieldDefinitionInput
): Promise<Result<CustomFieldDefinitionView>> {
  const response = await request.post<Result<CustomFieldDefinitionView>>("CustomField/definitions", input);
  return response.data;
}

export async function updateCustomFieldDefinition(
  input: CustomFieldDefinitionInput
): Promise<Result<CustomFieldDefinitionView>> {
  const response = await request.put<Result<CustomFieldDefinitionView>>("CustomField/definitions", input);
  return response.data;
}

export async function deleteCustomFieldDefinition(id: number): Promise<Result<boolean>> {
  const response = await request.delete<Result<boolean>>(`CustomField/definitions/${id}`);
  return response.data;
}

// ── Per-employee values ────────────────────────────────────────────────────────

export async function getUserCustomFieldValues(userId: string): Promise<Result<UserCustomFieldValueView[]>> {
  const response = await request.get<Result<UserCustomFieldValueView[]>>(
    `CustomField/users/${encodeURIComponent(userId)}/values`
  );
  return response.data;
}

export async function setUserCustomFieldValues(
  userId: string,
  values: UserCustomFieldValueInput[]
): Promise<Result<boolean>> {
  const response = await request.put<Result<boolean>>(
    `CustomField/users/${encodeURIComponent(userId)}/values`,
    { values }
  );
  return response.data;
}
